import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';

const AlertConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  icon: Icon,
  iconColorClass = 'text-red-500',
  title,
  message,
  details,
  note,
  confirmText = 'تأكيد',
  cancelText = 'إلغاء',
  confirmButtonClass = 'bg-red-600 hover:bg-red-700 dark:bg-red-500 dark:hover:bg-red-600',
  noteClass = 'text-red-600 dark:text-red-400',
  size = 'md'
}) => {
  const sizeClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '3xl': 'max-w-3xl',
    '4xl': 'max-w-4xl',
    '5xl': 'max-w-5xl',
    '6xl': 'max-w-6xl',
    '7xl': 'max-w-7xl',
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={onClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-200"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25 dark:bg-black/50 backdrop-blur-sm" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="min-h-screen px-4 text-center">
            <span className="inline-block h-screen align-middle" aria-hidden="true">&#8203;</span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-200"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className={`inline-block w-full ${sizeClasses[size]} p-8 my-8 overflow-hidden text-center align-middle transition-all transform bg-white dark:bg-gray-800 shadow-xl rounded-lg border border-gray-200 dark:border-gray-700`}>
                <div className="text-center mb-6">
                  <div className="mx-auto flex justify-center items-center mb-4">
                    <Icon className={`h-16 w-16 ${iconColorClass} animate-pulse`} />
                  </div>
                  <Dialog.Title as="h3" className="text-xl font-bold text-gray-900 dark:text-white mb-2">
                    {title}
                  </Dialog.Title>
                  <div className="text-gray-500 dark:text-gray-100 mt-4 mb-6">
                    <p>{message}</p>
                    {details && (
                      <p className="font-bold text-lg mt-2 text-gray-700 dark:text-gray-200">"{details}"</p>
                    )}
                    {note && (
                      <p className={`mt-2 text-sm ${noteClass}`}>{note}</p>
                    )}
                  </div>
                </div>

                <div className="flex justify-center gap-3">
                  <button
                    type="button"
                    className="px-6 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-gray-600 rounded-md hover:bg-gray-200 dark:hover:bg-gray-500 transition-colors duration-200 min-w-[120px] focus:outline-none"
                    onClick={onClose}
                  >
                    {cancelText}
                  </button>
                  <button
                    type="button"
                    className={`px-6 py-2.5 text-sm font-medium text-white ${confirmButtonClass} rounded-md transition-colors duration-200 min-w-[120px] focus:outline-none`}
                    onClick={onConfirm}
                  >
                    {confirmText}
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default AlertConfirmModal;
